require('./stepsView.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ actions
const RASuitabilityTestWizardActions = require('actions/RASuitabilityTestWizardActions');
const formActions = require('react-redux-form').actions;
const RASuitabilityTest = require('actions/RASuitabilityTest');
// @ components
const RAIncomingOutgoingStep = require('components/RAComponents/RAIncomingOutgoingStep/RAIncomingOutgoingStep');
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
// @ utilities
import { formatText } from 'core/i18n';
const UtagHelper = require('utilities/utagHelper');
// @ constants
const { PATH_GBI_TI, PATH_ROBO_TI } = require('constants/uTagConstants/paths');
const { SUITABILITY_TEST_MODEL_ANSWERS, SUITABILITY_TEST_PROFILE_MODEL_ANSWERS } = require('constants/RAConstants');
const {
    TEST_PROCESS_STEP_STEP_8,
    EVENT_CATEGORY_SUITABILITY_TEST,
    EVENT_DETAIL_QUESTION_LOAD,
    EVENT_DETAIL_TOOLTIP,
    EVENT_DETAIL_BUTTON_PREV,
    EVENT_DETAIL_BUTTON_NEXT,
} = require('constants/uTagConstants/RAConstants');
const { ROBO } = require('constants/userProfile');

class RAIncomesExpensesStepComponent extends React.Component {
    constructor(props) {
        super(props);

        this.onHandleContinueButton = this.onHandleContinueButton.bind(this);
        this.onHandlePrevButton = this.onHandlePrevButton.bind(this);
        this.onUpdatedIncomingValue = this.onUpdatedIncomingValue.bind(this);
        this.onUpdatedOutgoingValue = this.onUpdatedOutgoingValue.bind(this);
    }

    componentDidMount() {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_8,
            EVENT_DETAIL_QUESTION_LOAD,
            userProfile
        );
    }

    onHandleContinueButton() {
        const { RATestWizard, raSuitabilityTestWizardActions, userProfile, immSuitabilityTest } = this.props;
        const step = RATestWizard.currentStep;
        const substep = RATestWizard.currentSubStep;
        const { lastSubStep } = RATestWizard;
        const finalized = RATestWizard.steps?.[step].steps?.[substep].finished;
        const { answers } = immSuitabilityTest;
        const outgoingValue = answers?.[321];

        const data = {
            step,
            substep,
        };

        if (finalized) {
            raSuitabilityTestWizardActions.nextStep(data);
        } else if (lastSubStep) {
            raSuitabilityTestWizardActions.finishStep(data);
        } else {
            raSuitabilityTestWizardActions.finishSubStep(data);
        }
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_8,
            `${EVENT_DETAIL_BUTTON_NEXT}, ${outgoingValue}`,
            userProfile
        );
    }

    onHandlePrevButton() {
        const { RATestWizard, raSuitabilityTestWizardActions, userProfile } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const data = {
            currentStep,
            currentSubStep,
        };

        raSuitabilityTestWizardActions.prevStep(data);
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_8,
            EVENT_DETAIL_BUTTON_PREV,
            userProfile
        );
    }

    onUpdatedIncomingValue(value) {
        const { formActions, raSuitabilityTest } = this.props;
        formActions.change(`${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.320`, value);
        raSuitabilityTest.updateIncomingValue(value);
    }

    onUpdatedOutgoingValue(value) {
        const { formActions, raSuitabilityTest } = this.props;
        formActions.change(`${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.321`, value);
        this.recordEvent(value);
        raSuitabilityTest.updateOutgoingValue(value);
    }

    recordEvent = (eventDetail = '', eventCategory = EVENT_CATEGORY_SUITABILITY_TEST) => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(pathForTag, eventCategory, TEST_PROCESS_STEP_STEP_8, eventDetail, userProfile);
    };

    recordEventTooltipClick = (eventDetail = '') => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;

        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_8,
            `${eventDetail} ${EVENT_DETAIL_TOOLTIP}`,
            userProfile
        );
    };

    getContent() {
        const { immSuitabilityTest } = this.props;
        const immAnswers = immSuitabilityTest.get('answers');
        const immQuestions = immSuitabilityTest.get('questions');
        const incomingValue = immAnswers.get('320');
        const outgoingValue = immAnswers.get('321');
        const incomingOutgoingsTitle = immQuestions.getIn(['320', 'title']);

        return (
            <RAIncomingOutgoingStep
                disabled={false}
                incomingValue={incomingValue}
                outgoingValue={outgoingValue}
                title={incomingOutgoingsTitle}
                updateIncomingValue={this.onUpdatedIncomingValue}
                updateOutgoingValue={this.onUpdatedOutgoingValue}
                recordEventTooltipClick={this.recordEventTooltipClick}
            />
        );
    }

    isDisabled() {
        const { userProfile } = this.props;
        let disabled = false;

        if (
            (userProfile?.RASuitabilityTest?.answers?.['320'] ?? -1) < 0 ||
            (userProfile?.RASuitabilityTest?.answers?.['321'] ?? -1) < 0
        ) {
            disabled = true;
        }

        return disabled;
    }

    render() {
        const { RATestWizard } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const hidePrev = currentStep === 0 && currentSubStep === 0;
        const content = this.getContent();
        const disabled = this.isDisabled();

        return (
            <div>
                <div className="steps-view">{content}</div>
                <hr />
                <div className="steps-view__footer">
                    <RoadmapNavigation
                        buttonContinueType="submit"
                        buttonContinueAction={this.onHandleContinueButton}
                        buttonContinueText={formatText('suitabilityTest-next')}
                        buttonPrevText={formatText('suitabilityTest-prev')}
                        buttonPrevHidden={hidePrev}
                        buttonCancelText={formatText('suitabilityTest-getOut')}
                        buttonPrevAction={this.onHandlePrevButton}
                        buttonContinueDisabled={disabled}
                    />
                </div>
            </div>
        );
    }
}

export const RAIncomesExpensesStep = connect(
    state => ({
        userProfile: state.userProfile,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
        products: state.products,
    }),
    dispatch => ({
        raSuitabilityTestWizardActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        raSuitabilityTest: bindActionCreators(RASuitabilityTest, dispatch),
    })
)(RAIncomesExpensesStepComponent);
